module.exports = __webpack_public_path__ + "img/NL429.53b7a99c.png";